<template>
  <div class="cart_product-floating">
    <div class="box_cart-option">
      <!-- S : 마아팩 일괄주문제품 보기 -->
      <div class="txt_order-title">	
        <div class="promotion price-tip">
          <div class="promotion-tip">
            <button type="button" class="tooltip-btn">최종 결제금액</button>
          </div>
          <div class="promotion-tip-alert">
            <ul class="number-list">
              <li v-for="product in packInfo" :key="product.req_no">
                <p>{{ product.mypack_name }}</p>
                <p>	<span><mpn-label-number :amount="product.total_price" />원</span> <span class="pv_bv">PV/BV <mpn-label-number :amount="product.total_pv" />/<mpn-label-number :amount="product.total_bv"/> </span></p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- E : 마아팩 일괄주문제품 보기 -->
      <div class="box_cart-info">
        <div class="box_row-group">
          <div class="box_row-info">
            <p class="txt_total-title">
              주문금액(원)
            </p>
            <p class="txt_total-info">
              <mpn-label-number :amount="adjustedPrice" />
            </p>
          </div>
          <div class="box_row-info">
            <p class="txt_total-title">
              배송비(1곳)
            </p>
            <p class="txt_total-info">
              <mpn-label-number :amount="deliveryFee" />
            </p>
          </div>
          <div class="box_row-info">
            <p class="txt_total-title">
              포장비
            </p>
            <p class="txt_total-info">
              <mpn-label-number :amount="packageFee" />
            </p>
          </div>
          <div class="box_row-info">
            <p class="txt_total-title">
              할인정보
            </p>
            <p class="txt_total-info">
              0
            </p><!-- D : 2020-07-29 할인 금액이 있을 경우 [discount] class add -->
          </div>
        </div>
        <div class="box_row-info box_price">
          <p class="txt_total-title">
            결제금액
          </p>
          <p class="txt_total-info">
            <mpn-label-number :amount="priceInfo.totalPrice" />
          </p>
        </div>
        <div class="box_row-info box_total">
          <p class="txt_total-title">
            총 PV/BV
          </p>
          <p class="txt_total-info">
            <span class="text_price-pv"><mpn-label-number :amount="priceInfo.totalPv" /> /</span>
            <span class="text_price-bv"><mpn-label-number :amount="priceInfo.totalBv" /></span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {promotionTooltip} from '@/utils/publishedJs';
export default {
  name: 'RightInfo',
  props: {
    priceInfo: {
      type: Object,
      default: () => {},
    },
    deliveryFee: {
      type: Number,
      default: 0,
    },
    packageFee: {
      type: Number,
      default: 0,
    },
    packInfo: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    adjustedPrice() {
      return this.priceInfo.totalPrice - this.deliveryFee - this.packageFee;
    },
  },
  mounted() {
    promotionTooltip();
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/order/complete/partial/RightInfo.vue